import * as React from "react";
import styled from "styled-components";
import {
  Column,
  Columns,
  Hidden,
  Stack,
  Heading,
  Text,
} from "@origin-digital/ods-core";
import { BreadcrumbsController } from "../Breadcrumbs";
import { SearchBarController } from "../SearchBar";
import { LoginViewMessagesController } from "../LoginViewMessages";

interface IProps {
  title: string;
  description?: string;
  isNative: boolean;
  hideTitleAndDescription?: boolean;
  hideBreadcrumbs: boolean;
  titleIsHeading?: boolean;
}

const StyledBreadCrumbsCompact = styled.div`
  .MuiBreadcrumbs-root {
    margin-top: -16px;
    margin-bottom: 72px;
  }
`;

const SearchBannerHeading = ({
  title,
  titleIsHeading,
}: {
  title: string;
  titleIsHeading: boolean;
}) => (
  <>
    <Hidden above="md">
      <Heading
        data-id="search-banner-title"
        weight="medium"
        component={titleIsHeading ? "h1" : "h2"}
        variant="h2"
      >
        {title}
      </Heading>
    </Hidden>
    <Hidden below="lg">
      <Heading
        component={titleIsHeading ? "h1" : "h2"}
        variant="h3"
        data-id="search-banner-title"
      >
        {title}
      </Heading>
    </Hidden>
  </>
);

export const SearchBanner = (props: IProps) =>
  props.hideTitleAndDescription ? (
    <SearchBannerCompact {...props} />
  ) : (
    <SearchBannerFull {...props} />
  );

const SearchBannerFull = ({
  hideBreadcrumbs,
  isNative,
  title,
  description,
  titleIsHeading = true,
}: IProps) => (
  <Stack space="xlarge">
    {!hideBreadcrumbs && (
      <Hidden below="md">
        <BreadcrumbsController />
      </Hidden>
    )}
    <Columns collapseBelow="lg" space={["none", "xlarge"]} alignY="bottom">
      <Column width="1/2">
        <Stack space={["large", "xlarge"]}>
          <Stack space={"large"}>
            <SearchBannerHeading
              title={title}
              titleIsHeading={titleIsHeading}
            />
            {!isNative && (
              <Text tone="neutral" data-id="description">
                {description}
              </Text>
            )}
          </Stack>
          <SearchBarController />
        </Stack>
      </Column>
      <LoginCardColumn isNative={isNative} />
    </Columns>
  </Stack>
);

const SearchBannerCompact = ({ hideBreadcrumbs, isNative }: IProps) => (
  <Stack space="xlarge">
    <Columns collapseBelow="lg" space={["none", "xlarge"]} alignY="bottom">
      <Column width="1/2">
        <Stack space={["large", "xlarge"]}>
          {!hideBreadcrumbs && (
            <Hidden below="md">
              <StyledBreadCrumbsCompact>
                <BreadcrumbsController />
              </StyledBreadCrumbsCompact>
            </Hidden>
          )}
          <SearchBarController />
        </Stack>
      </Column>
      <LoginCardColumn isNative={isNative} />
    </Columns>
  </Stack>
);

const LoginCardColumn = ({ isNative }: { isNative: boolean }) => (
  <Column width="1/2">
    <Hidden below="lg">
      <Columns collapseBelow="lg" space="xlarge">
        <Column width="1/3">
          <Hidden below="md">&nbsp;</Hidden>
        </Column>
        <Column width="2/3">
          <Hidden below="md">
            {!isNative && (
              <LoginViewMessagesController
                backgroundColor="white"
                data-id="searchBanner-LoginViewMessages"
              />
            )}
          </Hidden>
        </Column>
      </Columns>
    </Hidden>
  </Column>
);
